import React, { createContext, useContext, useState, useEffect } from 'react';

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchContent = async () => {
        try {
            setLoading(true);
            // In production, this URL would be your CMS API or a hosted JSON file
            // Adding a timestamp to prevent caching during development/updates
            const response = await fetch(`/content.json?t=${new Date().getTime()}`);
            if (!response.ok) throw new Error('Failed to fetch content');
            const data = await response.json();
            setContent(data);
        } catch (err) {
            console.error('Error fetching content:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContent();
    }, []);

    return (
        <ContentContext.Provider value={{ content, loading, error, refreshContent: fetchContent }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => {
    const context = useContext(ContentContext);
    if (!context) {
        throw new Error('useContent must be used within a ContentProvider');
    }
    return context;
};
